import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { translate, handleFormKeyDown, isNullOrEmpty } from '../../utils/util';
import LoadUnloadService from '../../services/LoadUnloadService';
import { Title, Subtitle, Button, BackButton } from '../../components/UI/ComponentsUI';
import { onValueChange, validateInputsRequired } from '../../utils/handleChangeHooks';
import SelectNew from '../../components/UI/SelectNew';

const LoadUnloadParameters = (props) => {
    const [model, setModel] = useState({ shed: props.shed || '', movementType: props.movementType });
    const [movementTypes, setMovementTypes] = useState([]);

    const onChange = (event) => {
        onValueChange(event, model, setModel);
    };

    useEffect(() => {
        props.loadSheds();
        if (!isNullOrEmpty(model.shed)) {
            filterMovementsType(model.shed)
        }
        // eslint-disable-next-line
    }, []);

    const submit = () => {
        if (validateInputsRequired('formLoadUnloadParameters')) {
            const shedFilter = props?.sheds.find(f => f.id === parseInt(model.shed))
            const movementFilter = shedFilter?.movementTypes.find(f => f.movementTypeId === parseInt(model.movementType))
            props.setMovementType(model.movementType, movementFilter);
            props.setShed(model.shed, shedFilter);
            props.clear();
            props.history.push({ pathname: '../loadunload/loadunload', ...props });
        }
    }

    const filterMovementsType = (shed) => {
        if (!isNullOrEmpty(shed) && props?.sheds) {
            var data = props?.sheds.find(f => f.id === parseInt(shed))?.movementTypes
            setMovementTypes(data);
        } else {
            setMovementTypes([])
        }
    }

    return (
        <div>
            <BackButton {...props} />
            <div className="container-fluid h-65">
                <div className="row">
                    <Title icon="mdi mdi-clipboard-check" label={translate('configurations', 'general')} />
                    <Subtitle icon="mdi mdi-layers" label={translate('menu:load-unload')} />
                </div>
            </div>
            <div className="container-fluid" style={{ marginTop: '25px', }}>
                <div className="container">
                    <div className="card">
                        <div className="card-content" style={{ padding: '10px', paddingBlockEnd: '1px' }}>
                            <div>
                                <form id="formLoadUnloadParameters" className="col s12" onKeyDown={(e) => handleFormKeyDown(e, submit)}>
                                    <div className="row" style={{ marginBottom: '0px' }}>

                                        <div className="input-field col s12">
                                            <SelectNew
                                                required
                                                id={'shed'}
                                                name="shed"
                                                label={translate('shed', 'physical-confirmation')}
                                                placeHolder={translate('choose-one-option', 'general')}
                                                data={props?.sheds ? props.sheds.map((i) => {
                                                    return { id: i.id, text: i.code };
                                                }) : []} value={model.shed}
                                                change={(evt) => {
                                                    onChange(evt);
                                                    filterMovementsType(evt.target.value);
                                                }}
                                            />
                                        </div>
                                        <div className="input-field col s12">
                                            <SelectNew
                                                required
                                                id={'movementType'}
                                                name="movementType"
                                                label="Tipo Movimentação"
                                                placeHolder={translate('choose-one-option', 'general')}
                                                data={movementTypes.map((i) => {
                                                    return { id: i.movementType.id, text: i.movementType.description };
                                                })}
                                                value={model.movementType || ''}
                                                change={onChange}
                                            />
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div className="row" style={{ paddingTop: '10px' }}>
                                <div className="col s6">
                                    <Button full="true" onClick={() => props.history.go(-1)} text={translate('cancel', 'general')} secundary="true" />
                                </div>
                                <div className="col s6">
                                    <Button full="true" onClick={() => submit()} text={translate('confirm', 'general')} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        config: state.configReducer.config,
        sheds: state.loadUnloadReducer.sheds,
        shed: state.loadUnloadReducer.shed,
        movementType: state.loadUnloadReducer.movementType,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setMovementType: (movement, obj) => {
            dispatch(LoadUnloadService.setMovementType(movement, obj));
        },
        setShed: (shed, obj) => {
            dispatch(LoadUnloadService.setShed(shed, obj));
        },
        loadSheds: (callback) => {
            dispatch(LoadUnloadService.getShedsLoad(callback));
        },
        clear: () => {
            dispatch(LoadUnloadService.clearAll());
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(LoadUnloadParameters));
